const experienceData = [
  {
    role: "Teaching Assistant",
    company: "Eötvös Loránd University (ELTE), Faculty of Informatics",
    duration: "Sep 2025 – Present",
    description:
      "Teaching Assistant for the Application of Discrete Models course, guiding students in understanding core concepts and applying them using Python. Responsible for assisting in lectures, supporting students, and evaluating assignments and exam papers.",
    logo: "Elte_demonstrator.svg"
  },
  {
    role: "International Student",
    company: "HÖOK (Hungarian National Union of Students)",
    duration: "Sep 2025 – Present",
    description:
      "Active international student engaged in academic and cultural activities, collaborating in a diverse environment and adapting to global education standards.",
    logo: "HOOK.svg"
  },
  {
    role: "Software Engineer",
    company: "Bluestock Fintech",
    duration: "Dec 2025 – Feb 2026",
    description:
      "Worked on software development tasks in a fintech environment, contributing to application development, debugging, and improving system functionality.",
    logo: "Bluestock.svg"
  },
  {
    role: "Embedded Systems Intern",
    company: "Emertxe Information Technologies",
    duration: "Nov 2025 – Jan 2026",
    description:
      "Gained hands-on experience in embedded systems, working with low-level programming, hardware interaction, and system-level problem solving.",
    logo: "Emertxe.svg"
  },
  {
    role: "Web Developer",
    company: "The Sparks Foundation",
    duration: " Aug 2024 – March 2025",
    description:
      "Worked as a Web Developer Intern, contributing to website development tasks, improving front-end functionality, and gaining practical experience in web technologies and project-based development.",
    logo: "Spark.svg"
  }
];

export default experienceData;